/**
 * Web version only: after a deploy, open copies of the app reload themselves
 * so every viewer runs the current version. They wait until nothing is
 * playing, so a movie is never cut by an update.
 */
const CHECK_EVERY_MS = 5 * 60 * 1000;

let playing = 0;

/** The player marks itself open, so an update waits until it closes. */
export function markPlaybackOpen(open: boolean): void {
  playing += open ? 1 : -1;
}

async function newerBuildDeployed(): Promise<boolean> {
  try {
    const response = await fetch(`./version.json?${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return false;
    const { build } = (await response.json()) as { build?: string };
    return typeof build === 'string' && build !== __APP_BUILD__;
  } catch {
    return false;
  }
}

export function watchForUpdates(): void {
  // Packaged apps (TV, iPhone, Mac) update through their own installers.
  if (import.meta.env.DEV || typeof location === 'undefined' || !/^https?:$/.test(location.protocol)) return;
  let pending = false;
  const check = async () => {
    if (!pending) pending = await newerBuildDeployed();
    if (pending && playing === 0) location.reload();
  };
  setInterval(() => void check(), CHECK_EVERY_MS);
  // Coming back to the tab, or closing the player, applies a waiting update.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check();
  });
  setInterval(() => {
    if (pending && playing === 0) location.reload();
  }, 5000);
}
